module.exports = __webpack_public_path__ + "static/media/afbouwkeur-individual-logo.efe58ecd.png";